module.exports = __webpack_public_path__ + "static/media/left-arrow-light-theme.12da9270.svg";